<template>
    <div class="wrapttn">
        <div class="wrap2">
            <div class="wtops">
                <div class="topRect">
                    <div class="tit2">深蓝运维</div>
                    <!-- <div class="tit2">淮安市住房公积金</div> -->
                    <div class="subtit2">您身边的运维专家</div>
                </div>
                <img class="wpImg" src="./image/bg2.png">
            </div>
            <div class="wtBottom" v-if="yzmShow">
                <van-tabs v-model="active" class="ffntWrapn" @click="onClick">
                    <van-tab title="密码登录">
                        <div class="blk2">
                            <div class="input1">
                                <img src="./image/phone-1@2x.png" class="img1" />
                                <div class="txtm">
                                    <van-field style="padding:0;width:100%;height:100%" v-model="engineerInfom.userName" rows="1" autosize type="textarea" placeholder="请输入手机号" />
                                </div>
                            </div>
                            <div class="input1">
                                <img src="./image/fftnpassword.png" class="img1" />
                                <div class="txtn">
                                    <van-field style="padding:0" class="fieldV" v-model="engineerInfom.password" type="password" placeholder="请输入密码" />
                                </div>
                            </div>
                        </div>
                        <div class="ffntlook">
                            <div class="ffntlook1" @click="yzShow">忘记密码</div>
                        </div>
                        <div class="blk3">
                            <div class="blkt">
                                <div class="btn2" v-if="ubtnm" @click="toIndexm">登录</div>
                                <div class="btn2" v-else style="opacity:0.4">登录</div>
                            </div>
                        </div>
                    </van-tab>
                    <van-tab title="验证码登录">
                        <div class="blk2">
                            <div class="input1">
                                <img src="./image/phone-1@2x.png" class="img1" />
                                <div class="txtm">
                                    <van-field style="padding:0;width:100%;height:100%" v-model="engineerInfo.phone" rows="1" autosize type="textarea" placeholder="请输入手机号" />
                                </div>
                            </div>
                            <div class="input1">
                                <img src="./image/code@2x.png" class="img1" />
                                <div class="txtn">
                                    <van-field style="padding:0" class="fieldV" v-model="engineerInfo.code" rows="1" autosize type="textarea" placeholder="请输入验证码" />
                                </div>
                                <div class="txty" style="color:#b9d8f5" v-if="dShow">获取验证码</div>
                                <div v-else>
                                    <div>
                                        <div class="txty" v-show="!showDown" @click="verify">获取验证码</div>
                                    </div>
                                    <div>
                                        <div class="txty" v-show="showDown">{{time}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="blk3">
                            <div class="blkt">
                                <div class="btn2" v-if="ubtn" @click="toIndex">登录</div>
                                <div class="btn2" v-else style="opacity:0.4">登录</div>
                            </div>
                        </div>
                    </van-tab>
                </van-tabs>
            </div>
            <div class="wtBottom" v-if="!yzmShow">
                <van-tabs v-model="active" class="ffntWrapn">
                    <van-tab title="忘记密码">
                        <van-form @submit="toSubmit" :show-error-message="true">
                            <div class="blk2t">
                                <div class="input1">
                                    <img src="./image/phone-1@2x.png" class="img1" />
                                    <div class="txtm1">
                                        <van-field style="padding:0;width:100%;height:100%" v-model="editForm.phone" rows="1" autosize type="textarea" placeholder="请输入手机号" :rules="[{ required: true, message: '手机号不能为空' }]" />
                                    </div>
                                </div>
                                <div class="input1">
                                    <img src="./image/code@2x.png" class="img1" />
                                    <div class="txtn">
                                        <van-field style="padding:0" class="fieldV" v-model="editForm.verifyCode" rows="1" autosize type="textarea" placeholder="请输入验证码" :rules="[{ required: true, message: '验证码不能为空' }]" />
                                    </div>
                                    <div class="txty" style="color:#b9d8f5" v-if="dShow1">获取验证码</div>
                                    <div v-else>
                                        <div>
                                            <div class="txty" v-show="!showDown1" @click="verify1">获取验证码</div>
                                        </div>
                                        <div>
                                            <div class="txty" v-show="showDown1">{{time1}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="input1">
                                    <img src="./image/fftnpassword.png" class="img1" />
                                    <div class="txtn">
                                        <van-field style="padding:0" class="fieldV" v-model="editForm.password" type="password" placeholder="请输入密码" :rules="[{ required: true, message: '密码不能为空' }]" />
                                    </div>
                                </div>
                                <div class="input1">
                                    <img src="./image/fftnpassword.png" class="img1" />
                                    <div class="txtn">
                                        <van-field style="padding:0" class="fieldV" v-model="editForm.oncePassword" type="password" placeholder="请再次输入密码" :rules="[{ required: true, message: '密码不能为空' }]" />
                                    </div>
                                </div>
                            </div>
                            <div class="blk3">
                                <div class="blkt">
                                    <van-button round block type="info" class="btn2" native-type="submit">提交</van-button>
                                </div>
                            </div>
                        </van-form>
                    </van-tab>
                </van-tabs>
            </div>
            <customToast :toastRow="toastRow" :show="toastFlag"></customToast>
        </div>
    </div>
</template>
<script>
// import {Toast} from 'vant';
import customToast from "@/components/toast.vue";
import { getToken } from "@/util/auth.js";
import { mapActions } from "vuex";
export default {
    components: {
        customToast,
    },
    data() {
        return {
            toastFlag: false,
            toastRow: {},
            show: false,
            show1: false,
            engineerInfo: {
                phone: "",
                code: "",
                platForm: 0,
            },
            time: 60,
            timer: null,
            showDown: false,
            dShow: true,
            ubtn: false,
            error1: false,
            error2: false,
            error3: false,
            error4: false,
            yzmShow: true,
            active: 0,
            show1: true,
            engineerInfom: {
                password: "",
                userName: "",
            },
            editForm: {
                oncePassword: "",
                password: "",
                phone: "",
                verifyCode: "",
            },
            ubtnm: false,
            dShow1: true,
            showDown1: false,
            time1: 60,
            timer1: null,
        };
    },
    created() {
        document.title = "快速报修";
        // this.$route.query.id == 1
        if (this.$route.query.no_Login) {
            if (JSON.parse(this.$route.query.no_Login)) {
                this.engineerInfo.phone = this.$route.query.phone;
                this.engineerInfo.code = this.$route.query.code;
                this.toIndex();
            }
        }

        if (getToken()) {
            this.$router.push("/index");
        } else {
            setTimeout(() => {
                this.show = true;
            }, 3000);
        }
    },
    mounted() {
        if (getToken()) {
            this.$router.push("/index");
        } else {
            setTimeout(() => {
                this.show = true;
            }, 3000);
        }
        this.getCookie()
    },
    watch: {
        show() {
            if (this.show) {
                setTimeout(() => {
                    this.show1 = true;
                }, 100);
            }
        },
        engineerInfo: {
            handler(val, oldVal) {
                if (val.phone) {
                    this.dShow = false;
                }
                if (val.phone && val.code) {
                    this.ubtn = true;
                }
            },
            deep: true,
            immediate: true,
        },
        editForm: {
            handler(val, oldVal) {
                if (val.phone) {
                    this.dShow1 = false;
                    this.error1 = false;
                }
                if (val.verifyCode) {
                    this.error2 = false;
                }
                if (val.password) {
                    this.error3 = false;
                }
                if (val.oncePassword) {
                    this.error4 = false;
                }
            },
            deep: true,
            immediate: true,
        },
        engineerInfom: {
            handler(val, oldVal) {
                if (val.userName && val.password) {
                    this.ubtnm = true;
                }
            },
            deep: true,
            immediate: true,
        },
        time() {
            this.time = this.time;
        },
    },
    methods: {
        ...mapActions(["Login"]),
        ...mapActions(["Login1"]),
        onClick() {
            this.engineerInfo = {
                phone: "",
                code: "",
                platForm: 0,
            };
            this.engineerInfom = {
                password: "",
                userName: "",
            };
            this.ubtnm = false;
            this.ubtn = false;
            this.dShow = true;
            this.dShow1 = true;
        },
        yzShow() {
            this.yzmShow = false;
            clearInterval(this.timer);
        },
         //设置cookie
        setCookie(c_name, c_pwd, exdays) {
            var exdate = new Date();
            exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); 
            window.document.cookie = "userNameYH" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
            window.document.cookie = "password" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
        },
        //读取cookie
        getCookie() {
            if (document.cookie.length > 0) {
                var arr = document.cookie.split('; ');
                for (var i = 0; i < arr.length; i++) {
                    var arr2 = arr[i].split('='); 
                    if (arr2[0] == 'userNameYH') {
                        this.engineerInfom.userName = arr2[1]; 
                    } else if (arr2[0] == 'password') {
                        this.engineerInfom.password = arr2[1];
                    }
                }
                // this.checked = true;
            }
        },
        //清除cookie
        clearCookie: function() {
            this.setCookie("", "", -1); 
        },

        toIndex() {
            this.Login(this.engineerInfo).then((res) => {
                if (res.code != "0000") {
                    this.f(res.message);
                }
            });
        },
        toIndexm() {
            this.Login1(this.engineerInfom).then((res) => {
                if (res.code != "0000") {
                    // this.$toastf(res.message)
                    this.toastRow = {
                        selId: 5,
                        title: res.message,
                        text: res.message,
                    };
                    this.toastFlag = true;
                    setTimeout(() => {
                        this.toastFlag = false;
                    }, 1500);
                }
                this.setCookie(this.engineerInfom.userName, this.engineerInfom.password, 7);
            });
        },
        getTime() {},
        countDown1() {
            let that = this;
            that.timer1 = setTimeout(() => {
                that.time1 = that.time1 - 1;
                that.countDown1();
            }, 1000);
            if (that.time1 == 0) {
                clearTimeout(that.timer1);
                that.timer1 = "";
                that.showDown1 = !that.showDown1;
            }
        },
        verify1() {
            let data = { phone: this.editForm.phone };
            this.$api
                .get("/app/login/sendUpdatePasswordSmsCode", { params: data })
                .then((res) => {
                    if (res.data.code == "0000") {
                        this.showDown1 = !this.showDown1;
                        this.time1 = 60;
                        this.countDown1();
                    } else {
                        // this.$toast(res.data.message);
                        this.toastRow = {
                            selId: 5,
                            title: res.data.message,
                            text: res.data.message,
                        };
                        this.toastFlag = true;
                        setTimeout(() => {
                            this.toastFlag = false;
                        }, 1500);
                    }
                });
        },
        countDown() {
            let that = this;
            that.timer = setTimeout(() => {
                that.time = that.time - 1;
                that.countDown();
            }, 1000);
            if (that.time == 0) {
                clearTimeout(that.timer);
                that.timer = "";
                that.showDown = !that.showDown;
            }
        },
        verify() {
            let data = { phone: this.engineerInfo.phone };
            this.$api
                .get("/app/login/sendLoginSmsCode", { params: data })
                .then((res) => {
                    if (res.data.code == "0000") {
                        this.showDown = !this.showDown;
                        this.time = 60;
                        this.countDown();
                    } else {
                        // this.$toast(res.data.message);
                        this.toastRow = {
                            selId: 5,
                            title: res.data.message,
                            text: res.data.message,
                        };
                        this.toastFlag = true;
                        setTimeout(() => {
                            this.toastFlag = false;
                        }, 1500);
                    }
                });
        },
        toSubmit() {
            if (this.editForm.oncePassword != this.editForm.password) {
                // this.$toast("两次密码输入不一致");
                this.toastRow = {
                    selId: 4,
                    title: "两次密码输入不一致",
                    text: "两次密码输入不一致",
                };
                this.toastFlag = true;
                setTimeout(() => {
                    this.toastFlag = false;
                }, 1500);
            } else {
                this.$api
                    .post("/app/login/updateUserPassword", this.editForm)
                    .then((res) => {
                        if (res.data.code == "0000") {
                            this.yzmShow = true;
                            // this.$toast("修改成功");
                            this.toastRow = {
                                selId: 3,
                                title: "修改成功",
                                text: "您已成功修改密码",
                            };
                            this.toastFlag = true;
                            setTimeout(() => {
                                this.toastFlag = false;
                            }, 1500);
                            this.editForm = {
                                oncePassword: "",
                                password: "",
                                phone: "",
                                verifyCode: "",
                            };
                            clearInterval(this.timer1);
                        } else {
                            // this.$toast(res.data.message);
                            this.toastRow = {
                                selId: 5,
                                title: res.data.message,
                                text: res.data.message,
                            };
                            this.toastFlag = true;
                            setTimeout(() => {
                                this.toastFlag = false;
                            }, 1500);
                        }
                    });
            }
        },
    },
    beforeDestroy() {
        clearInterval(this.timer);
        clearInterval(this.timer1);
    },
};
</script>
<style scoped>
::v-deep .van-dialog {
    width: 75% !important;
}
.wrapttn {
    position: absolute;
    top: 0;
    left: 0;
    /* right:0;
		bottom:0; */
    width: 100%;
    height: 100%;
    z-index: 2001;
    overflow: hidden;
    background: linear-gradient(180deg, #0080ff, #0084ff);
}
@media only screen and (min-width: 1025px) {
    .wrap {
        height: 150%;
    }
}
.wrap1 {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
.wrap2 {
    position: absolute;
    top: 0px;
    left: 0;
    width: 100%;
    height: 100%;
}
.wpImg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
.wtop {
    width: 100%;
    height: 540px;
    padding: 0;
    box-sizing: border-box;
}
.wtops {
    position: absolute;
    width: 100%;
    height: 166px;
    padding: 30px 40px;
    box-sizing: border-box;
    transition: padding 0.5s linear;
}
.topRect {
    position: absolute;
    /* top:67px; */
    top: 30px;
    left: 24px;
    z-index: 3000;
}
.wbottom {
    position: absolute;
    top: 667px;
    left: 0px;
    width: 100%;
    height: 501px;
    background: #fff;
    border-radius: 24px 24px 0 0;
}
.wtBottom {
    position: absolute;
    z-index: 3000;
    position: absolute;
    top: 166px;
    left: 0;
    width: 100%;
    height: 1000px;
    background: #fff;
    border-radius: 24px 24px 0 0;
}

.login {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1000;
    width: 100%;
    height: 100%;
    background: #fff;
    overflow: hidden;
}
.lgTxt {
    width: 100%;
    height: 18px;
    padding: 12px 0;
    font-size: 18px;
    text-align: center;
    color: #324152;
    line-height: 27px;
    letter-spacing: 1px;
    font-weight: 500;
}
.tit2 {
    width: 200px;
    /* height: 56px; */
    opacity: 1;
    font-size: 36px;
    font-weight: 400;
    text-align: left;
    color: #ffffff;
}
.subtit2 {
    width: 200px;
    height: 28px;
    opacity: 1;
    font-size: 20px;
    font-weight: 400;
    text-align: left;
    color: #ffffff;
    letter-spacing: 1px;
}
.rect {
    width: 20px;
    height: 3px;
    background: #1878ff;
    border-radius: 2px;
    margin: 0 auto;
}
.blk1 {
    width: 100%;
    height: 246px;
}
.tit1 {
    width: 120px;
    height: 28px;
    font-size: 20px;
    font-weight: 400;
    text-align: left;
}
.subtit1 {
    width: 130px;
    height: 42px;
    font-size: 30px;
    font-weight: 400;
    text-align: left;
    color: #001f42;
    letter-spacing: 2px;
}
.bkm {
    flex: 0 0 206px;
}
.bkn {
    flex: 1;
    padding: 101px 8px 62px 36px;
}
.umbkn {
    width: 130px;
    height: 65px;
    padding-left: 10px;
    box-sizing: border-box;
    border-left: 4px solid #0080ff;
    vertical-align: top;
}
.blk2 {
    width: 303px;
    height: 128px;
    margin: 0 auto;
}
.blk2t {
    width: 303px;
    height: 228px;
    margin: 0 auto;
}
.input1 {
    position: relative;
    width: 100%;
    height: 44px;
    background: #ffffff;
    border-radius: 22px;
    border: 1px solid #e2e2e2;
    margin-top: 20px;
}
.img1 {
    position: absolute;
    top: 14px;
    left: 20px;
    width: 16px;
    height: 16px;
    margin-right: 20px;
}
.imgbg {
    width: 206px;
    height: 246px;
}
.txtm {
    position: absolute;
    left: 48px;
    height: 44px;
    line-height: 44px !important;
}
.txtm1 {
    position: absolute;
    left: 48px;
    height: 44px;
    line-height: 44px !important;
}
.txtm1 /deep/ .van-field--error {
    height: 64px !important;
}
.txtm1 .van-field--error .van-field__control,
.van-field--error /deep/ .van-field__control::placeholder {
    color: #6666;
}
.txtn {
    position: absolute;
    left: 48px;
    top: 0;
    width: 177px;
    height: 20px;
    line-height: 20px;
    margin-top: 12px;
}
.txty {
    position: absolute;
    top: 12px;
    right: 20px;
    border-left: 1px solid #e2e2e2;
    padding-left: 10px;
    font-size: 14px;
    font-weight: 400;
    color: #3e95ea;
}
.blk3 {
    margin-top: 60px;
    margin-bottom: 20px;
}
.blkt {
    flex: 1;
    display: flex;
    justify-content: center;
}
.btn2 {
    width: 303px;
    height: 44px;
    text-align: center;
    line-height: 44px;
    background: linear-gradient(116deg, #36b3fe 11%, #0080ff 91%);
    border-radius: 22px;
    border-radius: 22px;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
}
.fieldV {
    position: absolute;
    top: -12px;
    left: 0;
}
.iptxt {
    font-size: 15px;
    text-align: left;
    color: #324152;
    line-height: 23px;
    letter-spacing: 0px;
    height: 23px;
    margin-top: 20px;
}
/deep/ .van-field__body {
    height: 44px !important;
    line-height: 44px;
}
.van-field__body {
    height: 44px;
}
.ffntWrapn /deep/ .van-tabs__nav {
    background-color: transparent;
}
.ffntWrapn /deep/ .van-tabs__line {
    background-color: #0080ff;
}
.ffntWrapn /deep/ .van-tab {
    font-size: 18px;
    text-align: left;
    color: #333333;
    line-height: 27px;
    letter-spacing: 1px;
}
.ffntWrapn /deep/ .van-tab--active {
    font-size: 18px;
    text-align: left;
    color: #1878ff;
    line-height: 27px;
    letter-spacing: 1px;
}
.ffntlook {
    width: 100%;
    height: 20px;
    margin-top: 15px;
    padding: 0 43px;
    box-sizing: border-box;
    font-size: 16px;
    text-align: right;
    color: #1278ff;
    line-height: 24px;
    letter-spacing: 0px;
}
.ffntlook1 {
    width: 70px;
    height: 100%;
    float: right;
}
</style>
